module.exports = __webpack_public_path__ + "img/bi_middle_bg.78de04b1.png";